(() => {
  const sections = document.querySelectorAll('[data-fwp-section]');

  sections.forEach((section) => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          section.setAttribute('data-fwp-visible', 'true');
          observer.disconnect();
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -48px 0px'
      }
    );

    observer.observe(section);

    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    if (!finePointer.matches) return;

    const dot = section.querySelector('.fwp-cursor-dot');
    const ring = section.querySelector('.fwp-cursor-ring');
    if (!dot || !ring) return;

    let mouseX = 0;
    let mouseY = 0;
    let ringX = 0;
    let ringY = 0;
    let active = false;
    let rafId = null;

    const tick = () => {
      ringX += (mouseX - ringX) * 0.12;
      ringY += (mouseY - ringY) * 0.12;

      dot.style.left = `${mouseX}px`;
      dot.style.top = `${mouseY}px`;
      ring.style.left = `${ringX}px`;
      ring.style.top = `${ringY}px`;

      rafId = window.requestAnimationFrame(tick);
    };

    const interactiveSelector = '.fwp-stat, .fwp-row, .fwp-panel, .fwp-compare-grid';

    section.addEventListener('mouseenter', () => {
      if (active) return;
      active = true;
      section.classList.add('has-cursor');
      if (!rafId) rafId = window.requestAnimationFrame(tick);
    });

    section.addEventListener('mouseleave', () => {
      active = false;
      section.classList.remove('has-cursor', 'is-hovering');
    });

    section.addEventListener('mousemove', (event) => {
      mouseX = event.clientX;
      mouseY = event.clientY;
    });

    section.querySelectorAll(interactiveSelector).forEach((node) => {
      node.addEventListener('mouseenter', () => section.classList.add('is-hovering'));
      node.addEventListener('mouseleave', () => section.classList.remove('is-hovering'));
    });
  });
})();
